import { render, staticRenderFns } from "./PropertyOwnerForm.vue?vue&type=template&id=395b49b2"
import script from "./PropertyOwnerForm.vue?vue&type=script&lang=js"
export * from "./PropertyOwnerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports